module.exports = __webpack_public_path__ + "img/full3-min.cb1f9340.png";